import React from "react";
import { stats } from "../mock";

const Stats = () => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="pcb-card p-8 md:p-10 grid grid-cols-2 md:grid-cols-4 gap-6 reveal">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-4xl md:text-5xl font-extrabold text-emerald-400 text-glow-green">
                {s.value}
              </div>
              <div className="mt-1 text-sm text-emerald-100/70">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
